const Draggabilly = require('draggabilly');

export interface TaggedConfig {
    image: HTMLElement,
    storage: HTMLInputElement,
    amount?: number
}

type TagPosition = {
    [key: string]: number
};

export class Tagged {
    private readonly elements: {
        image: HTMLElement,
        storage: HTMLInputElement
    };
    protected amount: number;
    protected data: string[];
    protected draggie: any[] = [];

    constructor({image, storage, amount = 3}: TaggedConfig) {
        this.elements = {image, storage};
        this.amount = amount;
        this.init();
    }

    protected setData(i: number, x: number, y: number): void {
        this.data[i] = `${x},${y}`;
        this.elements.storage.value = this.data.join(';');
    }

    public getData(): string[] {
        const value = this.elements.storage.value;
        return value.split(';');
    }

    protected createElements(): void {
        const container = this.elements.image.parentElement;

        let list = document.createElement('ul');
        list.className = "tagged__list";

        container.style.position = `relative`;
        container.insertAdjacentElement('beforeend', list);

        for (let i = 0; i < this.amount; i++) {
            let item = document.createElement('li');
            item.className = "tagged__item";
            item.innerText = `${i + 1}`;
            list.insertAdjacentElement('beforeend', item);

            const draggie = new Draggabilly( item, {
                containment: true
            });
            this.draggie.push(draggie);

            const position = this.getStartPosition(item, i);
            draggie.setPosition( position.x, position.y);

            draggie.on( 'pointerUp', ( event: any, pointer: any ) => {
                const coordinates = {
                    x: Math.floor(draggie.position.x * 100 / container.clientWidth),
                    y: Math.floor((draggie.position.y + i * item.offsetHeight) * 100 / container.clientHeight)
                };

                this.setData(i, coordinates.x, coordinates.y);
            });
        }
    }

    public getStartPosition(item: HTMLElement, i: number): TagPosition {
        const
            coords = this.data[i].split(','),
            container = this.elements.image.parentElement;

        return {
            x: Math.floor(container.clientWidth / 100 * +coords[0]),
            y: Math.floor((container.clientHeight / 100 * +coords[1]) - i * item.offsetHeight)
        };
    }

    public updateElements(): void {
        this.draggie.forEach((it, i) => {
            const position = this.getStartPosition(it.element, i);
            it.setPosition(position.x, position.y);
        });
    }

    public init(): void {
        const {image} = this.elements;
        if (!image) return;

        this.data = this.getData();
        this.createElements();
    }
}